export default "__VITE_ASSET__Bbkhxq8Z__"